module.exports = __webpack_public_path__ + "static/media/khanda.ddffbee1.svg";